import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import WidgetBox, { WidgetTitle } from "../../../components/shared/widget-box"
import Mailchimp from "../../../components/forms/mailchimp-two"
import { FormWrapper, SubscribeText } from "./subscribe.stc"

const SearchWidget = ({ widgetStyle, widgetTitleStyle, inputStyle }) => {
  const subscribeQuery = useStaticQuery(graphql`
    query SubscribeQuery {
      allHomeJson(filter: { id: { eq: "home-mailchimp-content" } }) {
        edges {
          node {
            title
            id
            desc
          }
        }
      }
    }
  `)
  const queryResults = subscribeQuery.allHomeJson.edges[0].node
  return (
    <WidgetBox {...widgetStyle}>
      <WidgetTitle {...widgetTitleStyle}>Subscribe</WidgetTitle>
      <FormWrapper>
        <SubscribeText>{queryResults.desc}</SubscribeText>
        <Mailchimp />
      </FormWrapper>
    </WidgetBox>
  )
}

SearchWidget.defaultProps = {
  widgetStyle: {
    skin: "primary",
  },
  widgetTitleStyle: {
    color: "#fff",
  },
}

export default SearchWidget
